import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import LayersIndex from '@/views/Panel/LayersIndex.vue'
import ContextList from '@/views/Panel/ContextList.vue'
import LayersList from '@/views/Panel/LayersList.vue'
import Legend from '@/views/Panel/Legend.vue'
import SelectionInfoList from '@/views/Panel/SelectionInfoList.vue'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'context',
        name: 'ContextList',
        component: ContextList,
        meta: {
          panel: {
            label: 'Contextes'
          }
        }
      },
      {
        path: 'layers',
        name: 'LayersList',
        component: LayersList,
        meta: {
          panel: {
            label: 'Couches'
          }
        }
      },
      {
        path: 'legend',
        name: 'Legend',
        component: Legend,
        meta: {
          panel: {
            label: 'Légende'
          }
        }
      },
      {
        path: '/layers/index',
        name: 'LayersIndex',
        component: LayersIndex,
        props: true,
        meta: {
          panel: {
            label: 'Catalogue de couches',
            icon: 'mdi-layers-triple-outline'
          }
        }
      },
      {
        path: '/info-selection',
        name: 'InfoSelection',
        component: SelectionInfoList,
        meta: {
          panel: {
            label: 'Informations sélection'
          },
          style: {
            headerShadow: false
          }
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
